<template lang="pug">
.double-container(:class='{ modal: newModule }', v-if='info && price')
  flex-modal(
    title='膨胀优惠券',
    :btnText='btnTitle',
    :subBtnText='subBtnText',
    :btnDirection='newModule ? "column" : "row"',
    ref='modal',
    @cancel='cancel',
    @close='close',
    @confirm='confirm'
  )
    .modal-text.flex-mid(slot='body', :class='{ "new-module": newModule }')
      template(v-if='newModule')
        .title 当前优惠券可膨胀至
          span.yellow {{ price.swellPriceV2[0].value }}
          span {{ price.swellPriceV2[0].unit }}
          span {{ item.swellOfferType === MARKET_OFFER_TYPE.CARD ? "骑行卡" : "优惠券" }}
          span ，膨胀后该{{ item.swellOfferType === MARKET_OFFER_TYPE ? "骑行卡" : "优惠券" }}
          span.yellow 仅限APP使用
      template(v-else)
        .title
          span 从{{ price.currentPriceV2[0].value }}
          span {{ price.currentPriceV2[0].unit }}
          span {{ item.offerType === MARKET_OFFER_TYPE.COUPON ? "优惠券" : "骑行卡" }}
          span 膨胀至{{ price.swellPriceV2[0].value }}
          span {{ price.swellPriceV2[0].unit }}
          span {{ item.swellOfferType === MARKET_OFFER_TYPE.COUPON ? "优惠券" : "骑行卡" }}，
          span 膨胀后仅限APP使用
      .base-content
        .left-info.flex-mid
          .price
            span.current {{ price.currentPriceV2[0].value }}
            span.unit {{ price.currentPriceV2[0].unit }}
          .text
            span.prevDetail {{ title.title }}
          .btn(v-if='newModule') 普通{{ this.typeText.before }}
        .mid
        .right-info.flex-mid
          .price
            span.current {{ item.swellPriceV2[0].value }}
            span.unit {{ item.swellPriceV2[0].unit }}
          .text
            span.nextDetail {{ title.swellTitle }}
          .btn(v-if='newModule') APP专享{{ this.typeText.after }}
      .bottom(v-if='newModule') 优惠券膨胀后
        .yellow 不可撤销
</template>

<script>
import FlexModal from '@/components/flex-modal';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { MARKET_OFFER_TYPE } from '../../../const';

export default {
  components: {
    FlexModal,
  },
  data() {
    return {
      MARKET_OFFER_TYPE,
      info: null,
    };
  },
  computed: {
    price() {
      if (this.info) {
        const {
          item: { currentPriceV2, swellPriceV2 },
        } = this.info;
        return {
          currentPriceV2,
          swellPriceV2,
        };
      }
      return null;
    },
    item() {
      return (this.info || {}).item || {};
    },
    typeText() {
      return {
        before: this.item.offerType === MARKET_OFFER_TYPE.CARD ? '卡' : '券',
        after: this.item.swellOfferType === MARKET_OFFER_TYPE.CARD ? '卡' : '券',
      };
    },
    title() {
      if (this.info) {
        const {
          item: {
            title,
            detail: { swellPrizeDetail },
          },
        } = this.info;
        return {
          title,
          swellTitle: swellPrizeDetail.propertyName || '',
        };
      }
      return {};
    },
    newModule() {
      if (this.info) {
        return this.info.item.newModule;
      }
      return false;
    },
    btnTitle() {
      if (this.newModule) {
        return '立即膨胀';
      }
      return '去膨胀';
    },
    subBtnText() {
      if (this.newModule) {
        return '暂不膨胀';
      }
      return '不膨胀，直接用';
    },
  },
  methods: {
    open(info) {
      UBT.moduleExpose({
        pageId: 'Welfare',
        categoryId: 'platform',
        moduleId: 'expand_Popup',
        contentId: 'expand_Popup',
        exposureTimes: 1,
        businessInfo: {},
      });
      this.info = info;
      this.$nextTick(() => {
        this.$refs.modal.open();
      });
    },
    close() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'expand_Popup',
        categoryId: 'platform',
        businessInfo: {
          businessType: '2',
        },
      });
    },
    cancel() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'expand_Popup',
        categoryId: 'platform',
        businessInfo: {
          businessType: '1',
        },
      });
      if (this.newModule) {
        this.$emit('cancel', this.info);
      }
    },
    confirm() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'expand_Popup',
        categoryId: 'platform',
        businessInfo: {
          businessType: '0',
        },
      });
      this.$emit('confirm', this.info);
    },
  },
};
</script>

<style lang="less" scoped>
.bg(@w, @h, @url) {
  width: @w;
  height: @h;
  background-image: url(@url);
  background-size: 100% 100%;
}

.fontSize(@fz, @fw, @lh, @c) {
  font-size: @fz;
  font-weight: @fw;
  color: @c;
  line-height: @lh;
}

.omt(@to: ellipsis, @of: hidden, @ka: keep-all) {
  text-overflow: @to;
  overflow: @of;
  word-break: @ka;
}

.width(@wd) {
  width: @wd;
  max-width: @wd;
  min-width: @wd;
}

.modal-footer {
  /deep/ .btn {
    font-weight: 500;
  }
}

.modal-text {
  flex-direction: column;

  .title {
    width: 2.1rem;
    height: 0.4rem;
    margin-bottom: 0.3rem;
    .fontSize(0.14rem, 400, 0.2rem, #5a6066);
  }

  .base-content {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.15rem;

    .left-info {
      .bg(
        0.62rem,
        0.67rem,
        'https://m.hellobike.com/resource/AppPlatformH5/fuli/DtR0gtOWEzYO_ypuHK5Y1.png'
      );

      flex-direction: column;
    }

    .mid {
      .bg(
        0.26rem,
        0.14rem,
        'https://m.hellobike.com/resource/AppPlatformH5/fuli/-jEumF6OV098rv-Jl7ImJ.png'
      );

      align-self: center;
      margin: 0.1rem 0.15rem 0;
    }

    .right-info {
      .bg(
        0.79rem,
        0.91rem,
        'https://m.hellobike.com/resource/AppPlatformH5/fuli/63xVbL5U_GpdTlKOstRdG.png'
      );

      flex-direction: column;
      align-items: center;
    }

    .price {
      color: #ff5526;
      margin-top: 0.08rem;

      .current {
        font-family: 'DIN Alternate Bold', sans-serif;
        .fontSize(0.28rem, bold, 0.28rem, #ff5526);
      }

      .unit {
        margin-left: 0.01rem;
        position: relative;
        top: -1px;
        .fontSize(0.1rem, 500, 0.1rem, #ff5526);
      }
    }

    .text {
      margin-top: 0.01rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .fontSize(0.09rem, 400, 0.11rem, #87280d);

      .prevDetail {
        display: block;
        .width(0.6rem);
        .omt();
      }

      .nextDetail {
        display: block;
        .width(0.8rem);
        .omt();
      }
    }
  }

  &.new-module {
    .title {
      margin-bottom: 0.24rem;
      display: inline-block;
      .width(2.57rem);
    }

    .yellow {
      color: #ff5526;
      display: inline-block;
    }

    .btn {
      text-shadow: 0 0 0 #f75200;
      max-width: 0.84rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .fontSize(0.12rem, none, 0.16rem, #fff);
    }

    .text {
      margin-top: 0.01rem;
      white-space: normal;
      .width(0.7rem);
      .omt();

      .prevDetail,
      .nextDetail {
        overflow: visible;
        .width(0.7rem);
        .omt();
      }
    }

    .base-content {
      margin-bottom: 0.22rem;

      .left-info {
        .bg(
          0.8rem,
          0.93rem,
          'https://m.hellobike.com/resource/helloyun/15979/XdKFutpqXA.png'
        );

        .price {
          margin-top: 0.13rem;
        }

        .text {
          margin-bottom: 0.13rem;
        }

        .btn {
          margin-bottom: 0.04rem;
        }
      }

      .mid {
        padding: 0.02rem;
        .bg(
          0.26rem,
          0.14rem,
          'https://m.hellobike.com/resource/helloyun/15979/34UfNNo1Ut.png'
        );
      }

      .right-info {
        .bg(
          1.03rem,
          1.19rem,
          'https://m.hellobike.com/resource/helloyun/15979/0Bdfg8elJA.png'
        );

        .price {
          margin: 0.2rem 0 0;

          .current {
            font-size: 0.32rem;
          }
        }

        .text {
          margin-bottom: 0.18rem;
        }

        .btn {
          margin-bottom: 0.01rem;
          position: relative;
          top: 0.04rem;
          right: 0.015rem;
        }
      }
    }

    .bottom {
      .fontSize(0.12rem, 400, 0.17rem, #5a6066);
    }
  }
}

.modal {
  /deep/ .modal-container {
    .modal-footer {
      padding-top: 0.1rem;

      .cancel {
        color: #5a6066 !important;
        background: #f0f3f5;
      }

      .border {
        border: none !important;
      }
    }
  }
}
</style>
